export default __webpack_public_path__ + "static/media/2486.a4f9d6f4.png";